import { DEFAULT_QUERY_OPTIONS, useQueryWithBoundary } from '@/shared/lib/query';
import { glossaryKeys } from '@/shared/lib/query/queryKeys';

import { type ChildTermsResponse, fetchChildTerms } from '@/features/glossary/api';

export const useChildTerms = (parentFqn: string) => {
  return useQueryWithBoundary<ChildTermsResponse>({
    queryKey: glossaryKeys.childTerms(parentFqn),
    queryFn: () => fetchChildTerms(parentFqn),
    enabled: !!parentFqn,
    staleTime: 5 * 60 * 1000,
    ...DEFAULT_QUERY_OPTIONS,
  });
};
